import { render, staticRenderFns } from "./MySales.vue?vue&type=template&id=5275dc0e&scoped=true"
import script from "./MySales.vue?vue&type=script&lang=js"
export * from "./MySales.vue?vue&type=script&lang=js"
import style0 from "./MySales.vue?vue&type=style&index=0&id=5275dc0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275dc0e",
  null
  
)

export default component.exports